import { Typography } from "antd";
import styles from "./ProgressBar.module.css";

const { Text } = Typography;

// Интерфейс для пропсов прогресс-бара
export interface ProgressBarProps {
  value: number;
  max: number;
  color: string;
  showLabel?: boolean;
  height?: number;
  backgroundColor?: string;
}

// Стили для прогресс-бара

// Переиспользуемый компонент прогресс-бара
export const ProgressBar = ({
  value,
  max,
  color,
  showLabel = true,
  height = 8,
  backgroundColor = "#e9eaeb",
}: ProgressBarProps) => {
  const percentage = (value / max) * 100;

  return (
    <div className={styles.container}>
      <div
        className={styles.progressBar}
        style={{
          height: `${height}px`,
          background: backgroundColor,
        }}
      >
        <div
          className={styles.progressFill}
          style={{
            height: `${height}px`,
            width: `${percentage}%`,
            background: color,
          }}
        />
      </div>
      {showLabel && (
        <Text className={styles.label}>
          {value}/{max}
        </Text>
      )}
    </div>
  );
};
